import React from 'react';
import PropTypes from 'prop-types';
import { questionAndAnswerType } from '../../propTypes/questionAndAnswer';
import { generateFaqStructuredData } from '../../helpers/structuredData';
import { serializeMetadataForScriptTag } from '../SeoJsonLd';

const FaqStructuredData = ({ items }) => {
  const structuredData = generateFaqStructuredData(items);

  if (!structuredData) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: serializeMetadataForScriptTag(structuredData) }}
    />
  );
};

FaqStructuredData.propTypes = {
  items: PropTypes.arrayOf(questionAndAnswerType),
};

FaqStructuredData.defaultProps = {
  items: [],
};

export default FaqStructuredData;
